import { getIsoFormattedTs } from '../date';

export function serviceLogFormat(
  level: string,
  message: string,
  label: string,
  utcTimestamp: number,
): string {
  const timestampString = getIsoFormattedTs(utcTimestamp);
  return `${timestampString} - ${level}: [${label}] ${message}`;
}
